import { Collapse } from "antd";
import React from "react";
import styled from "styled-components";
import { EMAIL_URL } from "../../../constants/constants";

export const Faqs = () => {
  return (
    <Wrapper className="container x100" id="faqs">
      <div style={{ marginBottom: 40 }} className="textCenter flexColumn gap10">
        <h1 className="secondary" data-aos="fade-up" data-aos-duration="1500">
          Frequently Asked Questions
        </h1>
        <div
          className="grey font13"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="500"
        >
          Can’t find the answer you’re looking for? Reach out to our{" "}
          <a href={EMAIL_URL} className="main">
            customer support
          </a>{" "}
          team.
        </div>
      </div>

      <div data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1500">
        <Collapse
          accordion
          items={items}
          // bordered={false}
          expandIconPosition="end"
          className="faqAccordion"
          defaultActiveKey={0}
        />
      </div>
    </Wrapper>
  );
};

const items = [
  {
    label:
      "What is Credtics, and how can it benefit microfinance institutions?",
    children: (
      <p>
        Credtics is a credit management software that simplifies loan
        processing, tracking, and repayment collection for microfinance
        institutions, reducing costs and boosting efficiency. By automating
        workflows, providing real-time insights, and offering easy-to-use
        dashboards, it enhances decision-making, minimizes defaults, and
        improves customer service
      </p>
    ),
  },
  {
    label:
      "How does Credtics' credit management software improve loan tracking?",
    children: (
      <p>
        Credtics streamlines loan tracking by automating loan lifecycle
        management, providing real-time status updates, and sending reminders to
        borrowers. With customized reporting and centralized data, it enables
        institutions to easily monitor loan health, identify at-risk accounts,
        and ensure steady cash flow.
      </p>
    ),
  },
  {
    label:
      "What features does Credtics offer for financial reporting in microfinance?",
    children: (
      <p>
        Credtics includes automated financial reporting, customizable financial
        statements, and compliance-ready reports, allowing microfinance
        institutions to meet regulatory needs and gain insights into loan
        performance, revenue, and expenses for data-driven decision-making.
      </p>
    ),
  },
  {
    label:
      "Can Credtics help reduce loan defaults in microfinance institutions?",
    children: (
      <p>
        Credtics helps reduce loan defaults by automating borrower reminders,
        providing timely insights into loan repayment risks, and allowing
        institutions to adjust terms as needed, supporting healthy repayment
        rates and better portfolio management.
      </p>
    ),
  },
  {
    label:
      "What are the benefits of choosing Credtics over other credit management solutions?",
    children: (
      <p>
        Credtics offers microfinance-focused features such as loan tracking and
        compliance tools, along with a user-friendly interface and secure
        platform.
        <br />
        This tailored approach makes it ideal for microfinance institutions that
        require specialized solutions for managing large volumes of small loans.
      </p>
    ),
  },
  {
    label: "How secure is Credtics for handling sensitive financial data?",
    children: (
      <p>
        Credtics offers extensive onboarding, including personalized training,
        video tutorials, and live support, ensuring new users understand the
        platform. Ongoing assistance is available through multiple channels,
        helping users maximize Credtics’ benefits confidently.
      </p>
    ),
  },
  {
    label:
      "How does Credtics' credit management software improve loan tracking?",
    children: (
      <p>
        Credtics ensures data security with encryption, role-based access, and
        regular audits, along with multi-factor authentication and disaster
        recovery features, all designed to protect financial data and comply
        with privacy standards.
      </p>
    ),
  },
  {
    label:
      "Is Credtics’ credit management software customizable for different microfinance needs?",
    children: (
      <p>
        Credtics streamlines loan tracking by automating loan lifecycle
        management, providing real-time status updates, and sending reminders to
        borrowers. With customized reporting and centralized data, it enables
        institutions to easily monitor loan health, identify at-risk accounts,
        and ensure steady cash flow.
      </p>
    ),
  },
  {
    label:
      "How does Credtics support compliance with financial regulations in microfinance?",
    children: (
      <p>
        Credtics is highly customizable, allowing microfinance institutions to
        tailor loan terms, workflows, and reports to fit their operational and
        regulatory needs, making it adaptable as organizations grow and evolve.
      </p>
    ),
  },
  {
    label: "What support and training does Credtics provide for new users?",
    children: (
      <p>
        Credtics supports regulatory compliance by generating audit-ready
        reports, tracking transactions, and ensuring data transparency, helping
        institutions easily meet compliance requirements and reduce regulatory
        risks.
      </p>
    ),
  },
];

const Wrapper = styled.div`
  padding: 100px 20px;
  @media (max-width: 960px) {
    padding: 50px 20px;
  }
`;
